import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { registerStaff, getStaffs, getStaffById, updateStaff, deleteStaff, setActivePage, showLoading, hideLoading, openStaffModal } from '../actions';
import { Modal, Form, Button, Icon, Input, TextArea } from 'semantic-ui-react';
import * as generator from 'generate-password';

const roles = [
    { key: 'a', text: 'ADMIN', value: 'ADMIN' },
    { key: 'm', text: 'MANAGER', value: 'MANAGER' },
    { key: 's', text: 'STAFF', value: 'STAFF' },
    { key: 'S', text: 'SALES', value: 'SALES' },
]

const states = [
    { key: '1', text: 'ACTIVE', value: 'ACTIVE'},
    { key: '0', text: 'INACTIVE', value: 'INACTIVE'}
]

class StaffDetails extends Component {
    state = {
        staffModalOpen: false,
        selectedStaff: {
            name: '',
            email: '',
            phone: '',
            address: {
                address_1: '',
                address_2: '',
                postcode: '',
                town_city: '',
                state: '',
                country: ''
            },
            role: 'STAFF',
            remark: '',
            state: 'ACTIVE'
        },
        editable: false,
        deleteModal: false
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.staff !== nextProps.staff) {
            this.setState({
                selectedStaff: nextProps.staff.selectedStaff,
                staffModalOpen: nextProps.staff.staffModalOpen,
                deleteModal: (nextProps.staff.staffModalOpen) ? this.state.deleteModal : nextProps.staff.staffModalOpen,
                editable: (nextProps.staff.selectedStaff && nextProps.staff.selectedStaff.name) ? false : true
            });
        }
    }

    handleInput(e) {
        this.setState({
            selectedStaff: {
                ...this.state.selectedStaff,
                [e.target.name]: e.target.value
            }
        });
    }

    handleRoleSelect(e, {value}) {
        this.setState({
            selectedStaff: {
                ...this.state.selectedStaff,
                role: value
            }
        });
        console.log(value);
    }

    handleStateSelect(e, {value}) {
        this.setState({
            selectedStaff: {
                ...this.state.selectedStaff,
                state: value
            }
        });
        console.log(value);
    }

    handleAddressInput(e) {
        let newAddress = this.state.selectedStaff.address;
        newAddress[e.target.name] = e.target.value;

        this.setState({
            selectedStaff: {
                ...this.state.selectedStaff,
                address: newAddress
            }
        });
    }

    handleCloseStaffModal = () => {
        this.props.openStaffModal(false);
    }

    handleEditStaff = () => {
        this.setState({ editable: !this.state.editable });
    }

    handleSaveProfile = () => {
        const { selectedStaff } = this.state;

        // TODO: Validate email address is not empty before proceeding and add error handling when registration failed
        if (!selectedStaff._id) {
            let password = generator.generate({ length: 8, numbers: true });
            console.log('Password: ' + password);

            this.props.firebaseApp.auth().createUserWithEmailAndPassword(selectedStaff.email, password)
            .then((userCredential) => {
                console.log('Register staff successful');
                console.log(userCredential);
                selectedStaff._id = userCredential.user.uid;
                this.props.registerStaff(selectedStaff, password);
                // if (this.props.successHandle) {
                //     console.log('Register execute success handle');
                //     this.props.successHandle({ _id: userCredential.uid, provider: userCredential.providerData[0].providerId, email: userCredential.email });
                // }
            })
            .catch((err) => {
                console.log(err);
                if (err.code === 'auth/email-already-in-use') {
                    console.log('Account already exists in Auth');
                }
                alert('Register staff failed! ' + err.message);
            });
        } else {
            this.props.updateStaff(selectedStaff);
        }
    }

    handleDelete = (state) => {
        console.log('Delete ' + state);
        this.setState({ deleteModal: state });
    }

    confirmDelete = () => {
        this.props.deleteStaff({ _id: this.state.selectedStaff._id });
    }

    render() {
        const { selectedStaff, staffModalOpen, editable, deleteModal } = this.state;

        return (
            selectedStaff
                ? (
                    <Fragment>
                        <Modal
                            dimmer={true}
                            style={styles.modal}
                            open={deleteModal}
                            onOpen={this.handleDelete.bind(this, true)}
                            onClose={this.handleDelete.bind(this, false)}
                            size='small'
                        >
                            <Modal.Header>Confirm Delete</Modal.Header>
                            <Modal.Content>
                                <p>Are you sure you want to delete this staff?</p>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button onClick={this.handleDelete.bind(this, false)}>Cancel</Button>
                                <Button positive icon='check' content='OK' onClick={this.confirmDelete.bind(this, false)} />
                            </Modal.Actions>
                        </Modal>
                        <Modal open={staffModalOpen} style={styles.modal} onClose={this.handleCloseStaffModal.bind(this)}>
                            <Modal.Header>
                                {(selectedStaff._id) ? 'Staff Info' : 'Add Staff'}
                                {(selectedStaff._id) &&
                                    <div style={{ float: 'right' }}>
                                        <Icon name='trash' style={styles.modal_icon} onClick={this.handleDelete.bind(this, true)} />
                                        <Icon name='edit' style={styles.modal_icon} onClick={this.handleEditStaff.bind(this)} />
                                    </div>
                                }
                            </Modal.Header>
                            <Modal.Content>
                                <Form>
                                    <Form.Group>
                                        <Form.Field id='form-staff-name' name='name' label='Name' control={Input} type='text' value={selectedStaff.name} onChange={this.handleInput.bind(this)} readOnly={selectedStaff._id} width={8}/>
                                        <Form.Select id='form-staff-role' name='role' label="Role" options={roles} defaultValue='STAFF' value={selectedStaff.role} onChange={this.handleRoleSelect.bind(this)} disabled={!editable} width={4}/>
                                        <Form.Select id='form-staff-state' name='role' label="Status" options={states} defaultValue='ACTIVE' value={selectedStaff.state} onChange={this.handleStateSelect.bind(this)} disabled={!editable} width={4}/>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field id='form-staff-phone' name='phone' label='Phone' control={Input} type='tel' value={selectedStaff.phone} onChange={this.handleInput.bind(this)} readOnly={!editable} />
                                        <Form.Field id='form-staff-email' name='email' label='Email' control={Input} type='email' value={selectedStaff.email} onChange={this.handleInput.bind(this)} readOnly={selectedStaff._id} />
                                    </Form.Group>
                                    <Form.Field id='form-staff-address-street-1' name='address_1' control={Input} label='Address' placeholder='Address Line 1' value={selectedStaff.address.address_1} onChange={this.handleAddressInput.bind(this)} readOnly={!editable} />
                                    <Form.Field id='form-staff-address-street-2' name='address_2' control={Input} placeholder='Address Line 2' value={selectedStaff.address.address_2} onChange={this.handleAddressInput.bind(this)} readOnly={!editable} />
                                    <Form.Group widths='equal'>
                                        <Form.Field id='form-staff-address-postcode' name='postcode' control={Input} placeholder='Post Code' value={selectedStaff.address.postcode} onChange={this.handleAddressInput.bind(this)} readOnly={!editable} />
                                        <Form.Field id='form-staff-address-town_city' name='town_city' control={Input} placeholder='City' value={selectedStaff.address.town_city} onChange={this.handleAddressInput.bind(this)} readOnly={!editable} />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field id='form-staff-address-state' name='state' control={Input} placeholder='State' value={selectedStaff.address.state} onChange={this.handleAddressInput.bind(this)} readOnly={!editable} />
                                        <Form.Field id='form-staff-address-country' name='country' control={Input} placeholder='Country' value={selectedStaff.address.country} onChange={this.handleAddressInput.bind(this)} readOnly={!editable} />
                                    </Form.Group>
                                    <Form.Field
                                        id='form-staff-remarks'
                                        name='remarks'
                                        control={TextArea}
                                        label='Remarks'
                                        value={selectedStaff.remarks}
                                        onChange={this.handleInput.bind(this)}
                                        readOnly={!editable}
                                    />
                                </Form>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button onClick={this.handleCloseStaffModal.bind(this)}>Cancel</Button>
                                <Button positive icon='save' disabled={!editable} content='Save' onClick={this.handleSaveProfile.bind(this)} />
                            </Modal.Actions>
                        </Modal>
                    </Fragment>)
                : null
        )
    }
}

const styles = {
    modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    modal_icon: {
        width: '2em'
    }
};

const mapStateToProps = ({ auth, staff }) => {
    return { firebaseApp: auth.firebaseApp, staff }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        registerStaff: registerStaff,
        updateStaff: updateStaff,
        deleteStaff: deleteStaff,
        getStaffs: getStaffs,
        getStaffById: getStaffById,
        setActivePage: setActivePage,
        showLoading: showLoading,
        hideLoading: hideLoading,
        openStaffModal: openStaffModal
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(StaffDetails);